import $ from 'jquery';
import {getCookie} from "./cookies";

function getToken () {
  let data = (getCookie('user')) ? getCookie('user') : "";
  let token = data ? JSON.parse(data).token : "";
  return token;
}

function getData(url, gps) {
  return new Promise((resolve, reject)=>{
    $.ajax({
      url: url,
      headers : (gps === true) ? {
        "token" : getToken(),
        "moduleid" : 6
      } : {
				"token" : getToken(),
			},
      success: (data)=> {
        resolve(data);
      },
      error: (error)=> {
        reject(error);
      }
    });
  });
}

function getDataFromPIN(url) {
  return new Promise((resolve, reject)=>{
    $.ajax({
      url: url,
      success: (data)=> {
        resolve(data);
      },
      error: (error)=> {
        reject(error);
      }
    });
  });
}

function getDataSSO(url) {
  return new Promise((resolve, reject)=>{
    $.ajax({
      url: url,
      headers : {
				"token" : getCookie('token'),
        "module": 6,
			},
      success: (data)=> {
        resolve(data);
      },
      error: (error)=> {
        reject(error);
      }
    });
  });
}

function postData(url, data, gps, paramToken) {
  return new Promise((resolve, reject)=>{
    $.ajax({
      url: url,
      type: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      headers : (gps === true) ? {
        "token" :  getToken(),
        "moduleid" : 6
      } : {
				"token" : paramToken || getToken(),
			},
      data: JSON.stringify(data),
      success: (data)=> {
        resolve(data);
      },
      error: (error)=> {
        reject(error);
      }
    });
  }); 
}

function postDataWithOutToken(url, data) {
  return new Promise((resolve, reject)=>{
    $.ajax({
      url: url,
      type: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      data: JSON.stringify(data),
      success: (data)=> {
        resolve(data);
      },
      error: (error)=> {
        reject(error);
      }
    });
  }); 
}


function fileUpload(url, data) {
  return new Promise((resolve, reject)=>{
    $.ajax({
      url: url,
      type: 'POST',
      headers : {
				"token" : getToken()
      },
      processData : false,
      contentType : false,
      data: data,
      success: (data)=> {
        resolve(data);
      },
      error: (error)=> {
        reject(error);
      }
    });
  }); 
}
function putData(url, data, gps) {
  return new Promise((resolve, reject)=>{
    $.ajax({
      url: url,
      type: 'PUT',
      data: data,
      contentType: "application/json; charset=utf-8",
      headers : (gps === true) ? {
        "token" : getToken(),
        "moduleid" : 6
      } : {
				"token" : getToken(),
			},
      success: (data)=> {
        resolve(data);
      },
      error: (error)=> {
        reject(error);
      }
    });
  }); 
}

function putDataForMoglix(url, data) {
  return new Promise((resolve, reject)=>{
    $.ajax({
      url: url,
      type: 'PUT',
      data: data,
      headers : {
				"token" : getToken()
			},
      success: (data)=> {
        resolve(data);
      },
      error: (error)=> {
        reject(error);
      }
    });
  }); 
}
function putDatajson(url, data) {
  return new Promise((resolve, reject)=>{
    $.ajax({
      url: url,
      type: 'PUT',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      headers : {
        "token" : getToken()
      },
      data: JSON.stringify(data),
      success: (data)=> {
        resolve(data);
      },
      error: (error)=> {
        reject(error);
      }
    });
  });
}
function postDataForGetDetails(url, data) {
  return new Promise((resolve, reject)=>{
    $.ajax({
      url: url,
      type: 'POST',
      data: data,
      headers : {
        "token" : getToken()
			},
      success: (data)=> {
        resolve(data);
      },
      error: (error)=> {
        reject(error);
      }
    });
  }); 
}

function deleteData(url, data, stringify, gps) {
  return new Promise((resolve, reject)=>{
    $.ajax({
      url: url,
      type: 'DELETE',
      contentType: 'application/json; charset=utf-8',
      headers : (gps === true) ? {
        "token" : getToken(),
        "moduleid" : 6
      } : {
				"token" : getToken(),
			},
      data: stringify == "stringify" ? JSON.stringify(data) : (data),
      success: (data)=> {
        resolve(data);
      },
      error: (error)=> {
        reject(error);
      }
    });
  }); 
}

function postDataWithoutToken(url, data, broadcastToken) {
  return new Promise((resolve, reject)=>{
    $.ajax({
      url: url,
      type: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      headers : {
        "token" : broadcastToken || getToken()
      },
      data: JSON.stringify(data),
      success: (data)=> {
        resolve(data);
      },
      error: (error)=> {
        reject(error);
      }
    });
  }); 
}

export {
  getData,
  postData,
  putData,
  postDataForGetDetails,
  fileUpload,
  deleteData,
  postDataWithoutToken,
  getDataSSO,
  putDataForMoglix,
  getDataFromPIN,
postDataWithOutToken,
  putDatajson
};